import { render } from "./adminDashboardView.vue?vue&type=template&id=a18b81a2&scoped=true"
import script from "./adminDashboardView.vue?vue&type=script&lang=js"
export * from "./adminDashboardView.vue?vue&type=script&lang=js"

import "./adminDashboardView.vue?vue&type=style&index=0&id=a18b81a2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a18b81a2"]])

export default __exports__